module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xk-img-code",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('canvas', {
    attrs: {
      "id": "canvas-img-code",
      "width": "100",
      "height": "50"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2077386b","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/module/imgCode/src/imgCode.vue
// module id = 513
// module chunks = 0